import { FunctionComponent, useEffect, useRef, useState } from "react";
import "./Courses.scss";
import Table from "../../Components/Table/Table";
import CustomToolbar from "../../Components/Table/components/CustomToolbar";
import ButtonField from "../../Components/Button/ButtonField";
import { Columns } from "../../Components/Table/ITable";
import {
  GridRenderCellParams,
  GridValueFormatterParams,
} from "@mui/x-data-grid";
import { ICourseslist } from "./ICourse";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import Dialog from "../../Components/Dialog/Dialog";
import ResponseDialog from "../../Components/ResponseDialog/ResponseDialog";
import TableSearch from "../../Components/Table/components/TableSearch";
import { ReactComponent as Delete } from "../../Assets/Images/delete.svg";
import { ReactComponent as Edit } from "../../Assets/Images/edit.svg";
import { IDeleteDialog } from "../../Components/DeleteDialog/IDeleteDialog";
import IconButtonField from "../../Components/Button/IconButtonField";
import { SvgIcon } from "@mui/material";
import DeleteDialog from "../../Components/DeleteDialog/DeleteDialog";
import { ReactComponent as RefreshButton } from "../../Assets/Images/RefreshButton.svg";
import { listCourses } from "../../Redux/Slices/Courses/ListCoursesSlice";
import { clearAddCoursesResponse } from "../../Redux/Slices/Courses/AddCoursesSlice";
import {
  clearDeleteCoursesResponse,
  deleteCourses,
} from "../../Redux/Slices/Courses/DeleteCoursesSlice";
import { clearEditCoursesResponse } from "../../Redux/Slices/Courses/EditCoursesSlice";
import { listSideMenuPermission } from "../../Redux/Slices/SideMenuPermission/ListSideMenuPermissionSlice";
import { listExam } from "../../Redux/Slices/Exam/ListExamSlice";
import CoursesForm from "./SubjectForm";
import { listYearlevel_map } from "../../Redux/Slices/Yearlevel_map/ListYearlevel_mapSlice";

interface CoursesProps { }

const Courses: FunctionComponent<CoursesProps> = () => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState<boolean>(false);
  const [deleteDialogData, setDeleteData] = useState<IDeleteDialog>({});
  const [initialValues, setInitialValues] = useState<Partial<ICourseslist>>({
    exam_ids: [],
    status: true,
  });
  const dispatch = useAppDispatch();
  const { data: listCoursess } = useAppSelector(
    (state: any) => state.ListCoursesSlice
  );
  const { data: addCourses } = useAppSelector((state: any) => state.AddCoursesSlice);
  const { data: EditCourses } = useAppSelector(
    (state: any) => state.EditCoursesSlice
  );
  const { data: deleteCoursess } = useAppSelector(
    (state: any) => state.DeleteCourses
  );

  const permissions = useAppSelector((state: any) => state.PermissionsToPage);
  const finaldata = { permissions };

  const formRef = useRef<HTMLFormElement>(null);
  const columns: Columns = [
    {
      field: "index",
      renderHeader: () => <b>S.No</b>,
      width: 90,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "name",
      renderHeader: () => <b>Name</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      align: "left",
    },
    {
      field: "description",
      renderHeader: () => <b>Description</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      align: "left",
    },
    {
      field: "cost",
      renderHeader: () => <b>Cost</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      align: "left",
    },
    {
      field: "year_group",
      renderHeader: () => <b>Year Group</b>,
      flex: 1,
      headerAlign: "left",
      align: "left",
      renderCell: (params: GridRenderCellParams<ICourseslist>) => {
        return (
          <span>{params.row.yeargroup_str ?? params.row.year_group}</span>
        );
      },
    },
    {
      field: "duration",
      renderHeader: () => <b>Duration (days)</b>,
      flex: 1,
      type: "number",
      headerAlign: "left",
      align: "left",
    },
    {
      field: "features",
      renderHeader: () => <b>Features</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      align: "left",
      renderCell: (params: GridRenderCellParams<ICourseslist>) => {
        const features = [];
        if (params.row.exam) features.push("Exam");
        if (params.row.ai) features.push("AI");
        if (params.row.video) features.push("Video");
        if (params.row.study_note) features.push("Study Note");
        if (params.row.booklet) features.push("Booklet");
        const content = features.join(", ") || "-";
        return <span>{content}</span>;
      },
    },

    {
      field: "status",
      renderHeader: () => <b>Status</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      align: "left",
      cellClassName: (params: any) =>
        `activename ${params.row.status ? "active" : "inactive"}`,

      valueFormatter: (params: any) =>
        params.value === true ? "Active" : "Inactive",
    },

    {
      field: "action",
      renderHeader: () => <b>Action</b>,
      flex: 1,
      type: "actions",
      renderCell: (params: GridRenderCellParams<ICourseslist>) => {
        return (
          <>
            <IconButtonField
              disabled={finaldata?.permissions?.edit === false}
              onClick={() => {
                setInitialValues({ ...params.row, id: params.id as number });
                setIsEdit(true);
                setDialogOpen(true);
              }}
            >
              <SvgIcon sx={{ fill: "none" }} component={Edit} inheritViewBox />
            </IconButtonField>
            <IconButtonField
              disabled={finaldata?.permissions?.delete === false}
              onClick={() => {
                setDeleteData({ id: params.id, name: params?.row?.name });
                setDeleteDialogOpen(true);
              }}
            >
              <SvgIcon component={Delete} inheritViewBox />
            </IconButtonField>
          </>
        );
      },
    },
  ];

  const Courses = Array.isArray(listCoursess?.data)
    ? listCoursess?.data.map((user: any, index: number) => ({ ...user, index: index + 1 }))
    : [];

  useEffect(() => {
    dispatch(listExam());
    dispatch(listYearlevel_map());
    dispatch(listCourses());
    // dispatch(listSideMenuPermission());
  }, [addCourses, EditCourses, deleteCoursess, dispatch]);
  useEffect(() => {
    return () => {
      dispatch(clearAddCoursesResponse());
      dispatch(clearEditCoursesResponse());
      dispatch(clearDeleteCoursesResponse());
    };
  }, [dispatch]);
  return (
    <>
      <Table rows={Courses ?? []} columns={columns} exportFileName="Courses">
        <CustomToolbar>
          <h6></h6>
          <TableSearch />
          <ButtonField
            className="tabel_add_new_button"
            onClick={() => {
              setInitialValues({
                exam_ids: [],
                status: true,
              });
              setIsEdit(false);
              setDialogOpen(true);
            }}
            toolTip="Add new"
            disabled={finaldata?.permissions?.add === false}
          >
            Add new
          </ButtonField>
          <IconButtonField
            className="refresh_btn"
            toolTip="Refresh"
            onClick={() => dispatch(listCourses())}
          >
            <SvgIcon
              className="refresh_svg_icon"
              component={RefreshButton}
              inheritViewBox
            />
          </IconButtonField>
        </CustomToolbar>
      </Table>

      <Dialog
        open={dialogOpen}
        dialogClassName="dialog_double_input"
        Dialog_Title={`${isEdit ? "Update" : "Add"} Course`}
        Dialog_Content={
          <CoursesForm
            formRef={formRef}
            initialValues={initialValues}
            setInitialValues={setInitialValues}
          />
        }
        Dialog_Actions={
          <>
            <ButtonField
              className="form_cancel_button"
              onClick={() => {
                setDialogOpen(false);
                setIsEdit(false);
              }}
            >
              Cancel
            </ButtonField>
            <ButtonField
              className="form_save_button"
              onClick={() => formRef.current?.requestSubmit()}
            >
              Save
            </ButtonField>
          </>
        }
      />
      <ResponseDialog response={addCourses} parentDialog={setDialogOpen} />
      <ResponseDialog response={EditCourses} parentDialog={setDialogOpen} />
      <DeleteDialog
        deleteableName={deleteDialogData.name ?? ""}
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        deleteFunction={() => {
          dispatch(deleteCourses(deleteDialogData.id));
        }}
        response={deleteCoursess}
      />
    </>
  );
};

export default Courses;
